/**
 * SHOP VERVIERS - UI/UX PRO MAX E-COMMERCE JAVASCRIPT
 * Interactive Features: Dynamic Cart Drawer, Wishlist, Multi-Image Gallery,
 * Variant Switching, Countdown Timer, Toast Alerts & Full English Support
 */

(function () {
  'use strict';

  // In-memory cart items for seamless client demonstration & store preview
  let localCart = [
    {
      id: 'item_default_1',
      title: 'Pack Soda Pétillant Agrumes Chilled',
      price: 24.00,
      image: (window.themeAssets && window.themeAssets.defaultCartImage) || 'sparkling-fruit-soda.jpg',
      quantity: 1
    }
  ];

  let wishlist = new Set();
  try {
    const savedWishlist = localStorage.getItem('shop_verviers_wishlist');
    if (savedWishlist) {
      const parsed = JSON.parse(savedWishlist);
      if (Array.isArray(parsed)) {
        wishlist = new Set(parsed.map(String));
      }
    }
  } catch (e) {
    console.warn('Could not read wishlist from localStorage:', e);
  }
  const THRESHOLD = 25.00;

  window.theme = {
    // 0. Dark Mode & Theme Toggle
    toggleTheme: function () {
      const current = document.documentElement.getAttribute('data-theme') || 'dark';
      const next = current === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', next);
      localStorage.setItem('shop_verviers_theme', next);
      this.updateThemeUI(next);
      this.showToast(next === 'dark' ? 'Dark mode activated' : 'Theme mode updated');
    },

    updateThemeUI: function (theme) {
      const isDark = theme === 'dark';
      document.querySelectorAll('.theme-icon-slot').forEach(el => {
        el.innerHTML = isDark
          ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>'
          : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>';
      });
      document.querySelectorAll('.theme-label-slot').forEach(el => {
        el.textContent = isDark ? 'Light' : 'Dark';
      });
      document.querySelectorAll('.theme-toggle-btn').forEach(btn => {
        btn.setAttribute('title', isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode');
      });
    },

    initTheme: function () {
      const saved = localStorage.getItem('shop_verviers_theme');
      const defaultMode = document.documentElement.getAttribute('data-theme') || 'dark';
      const theme = (saved && (saved === 'dark' || saved === 'light')) ? saved : defaultMode;
      document.documentElement.setAttribute('data-theme', theme);
      this.updateThemeUI(theme);
    },

    // 0.1 Mobile Navigation Drawer
    toggleMobileMenu: function (open) {
      const drawer = document.getElementById('mobileNavDrawer');
      const overlay = document.getElementById('mobileNavOverlay');
      const isOpen = open !== undefined ? open : (drawer && !drawer.classList.contains('open'));
      if (drawer) {
        if (isOpen) drawer.classList.add('open');
        else drawer.classList.remove('open');
      }
      if (overlay) {
        if (isOpen) overlay.classList.add('active');
        else overlay.classList.remove('active');
      }
      document.body.style.overflow = isOpen ? 'hidden' : '';
    },

    // 1. Cart Drawer Controls
    openCart: function () {
      const drawer = document.getElementById('cartDrawer');
      const overlay = document.getElementById('drawerOverlay');
      if (drawer) drawer.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.renderCart();
    },

    closeCart: function () {
      const drawer = document.getElementById('cartDrawer');
      const overlay = document.getElementById('drawerOverlay');
      if (drawer) drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    },

    toggleCart: function () {
      const drawer = document.getElementById('cartDrawer');
      if (drawer && drawer.classList.contains('open')) {
        this.closeCart();
      } else {
        this.openCart();
      }
    },

    // 2. Add Custom Item to Cart
    addCustomItem: function (title, price, image) {
      const cleanPrice = parseFloat(price) || 0;
      const existing = localCart.find(item => item.title === title);
      if (existing) {
        existing.quantity += 1;
      } else {
        localCart.push({
          id: 'item_' + Date.now(),
          title: title,
          price: cleanPrice,
          image: image || '',
          quantity: 1
        });
      }

      this.updateCartCounts();
      this.renderCart();
      this.openCart();
      this.showToast(`Added to cart: ${title}`);
    },

    // 3. Change Quantity or Remove
    changeItemQty: function (id, newQty) {
      if (newQty <= 0) {
        localCart = localCart.filter(item => item.id !== id);
      } else {
        const item = localCart.find(item => item.id === id);
        if (item) item.quantity = newQty;
      }
      this.updateCartCounts();
      this.renderCart();
    },

    // 4. Update Header Badge Count & Floating Cart Total
    updateCartCounts: function () {
      const totalCount = localCart.reduce((sum, item) => sum + item.quantity, 0);
      const subtotal = localCart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
      const formattedTotal = subtotal.toFixed(2).replace('.', ',') + ' €';

      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = totalCount;
      });

      const headerTotal = document.getElementById('headerCartTotal');
      if (headerTotal) headerTotal.textContent = formattedTotal;

      const floatingTotal = document.getElementById('floatingCartTotal');
      if (floatingTotal) floatingTotal.textContent = formattedTotal;
    },

    // 4b. Multi-Image Thumbnail Switcher
    selectProductImage: function (url, el) {
      const mainImg = document.getElementById('mainProductImg');
      if (mainImg) {
        mainImg.style.opacity = '0.4';
        setTimeout(() => {
          mainImg.src = url;
          mainImg.style.opacity = '1';
        }, 120);
      }
      document.querySelectorAll('.thumb-item').forEach(t => {
        t.classList.remove('active');
        t.style.borderColor = 'var(--color-border)';
      });
      if (el) {
        el.classList.add('active');
        el.style.borderColor = 'var(--color-primary)';
      }
    },

    // 4c. Variant Selector Change Handler
    onVariantChange: function (selectEl) {
      const opt = selectEl.options[selectEl.selectedIndex];
      if (!opt) return;
      const price = opt.getAttribute('data-price');
      const compare = opt.getAttribute('data-compare');
      const available = opt.getAttribute('data-available') === 'true';

      const priceDisplay = document.getElementById('productPriceDisplay');
      if (priceDisplay && price) priceDisplay.textContent = price;

      const compareDisplay = document.getElementById('productComparePriceDisplay');
      if (compareDisplay) {
        if (compare && compare !== '') {
          compareDisplay.textContent = compare;
          compareDisplay.style.display = 'inline';
        } else {
          compareDisplay.style.display = 'none';
        }
      }

      const btn = document.getElementById('addToCartBtn');
      const btnText = document.getElementById('addToCartBtnText');
      if (btn && btnText) {
        if (available) {
          btn.removeAttribute('disabled');
          btn.style.opacity = '1';
          btnText.textContent = `Add to Cart • ${price}`;
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.style.opacity = '0.6';
          btnText.textContent = 'Sold Out';
        }
      }
    },

    // 4d. AJAX Add to Cart Handler
    handleProductFormSubmit: function (e) {
      e.preventDefault();
      const form = e.target;
      const btn = form.querySelector('[name="add"]');
      const originalText = btn ? btn.innerHTML : '';
      if (btn) {
        btn.setAttribute('disabled', 'disabled');
        btn.innerHTML = '<span>Adding...</span>';
      }

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => {
        if (!res.ok) throw new Error('Network response not ok');
        return res.json();
      })
      .then(item => {
        if (btn) {
          btn.removeAttribute('disabled');
          btn.innerHTML = originalText;
        }

        const title = item.title || item.product_title || 'Item';
        const price = (item.price / 100) || 0;
        const img = item.image || (document.getElementById('mainProductImg') ? document.getElementById('mainProductImg').src : '');
        window.theme.addCustomItem(title, price, img);
      })
      .catch(() => {
        if (btn) {
          btn.removeAttribute('disabled');
          btn.innerHTML = originalText;
        }
        // Fallback: add via custom item
        const titleEl = document.querySelector('.product-detail-title') || document.querySelector('.product-info-card h1');
        const priceEl = document.getElementById('productPriceDisplay');
        const imgEl = document.getElementById('mainProductImg');
        const title = titleEl ? titleEl.textContent.trim() : 'Craft Product';
        const price = priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9,.]/g, '').replace(',', '.')) : 4.50;
        const img = imgEl ? imgEl.src : '';
        window.theme.addCustomItem(title, price, img);
      });
    },

    // 4e. Full-Site Language Switcher (Default: English)
    switchLanguage: function (lang) {
      const translations = {
        en: {
          navHome: 'Home',
          navShop: 'Craft Beers & Shop',
          navAbout: 'Our Story',
          navFaq: 'FAQ & Help',
          navContact: 'Contact & Store',
          navCat: 'ALL CATEGORIES',
          navExpress: 'Express 30-min delivery',
          searchPlaceholder: 'Search craft beers, cold drinks, gourmet glaces, bourbon...',
          delivery: 'FREE Delivery from 25€ • At your door in 30 min',
          quality: '100% Curated Artisan & Chilled Freshness',
          cartItemsLabel: 'Items',
          addBtn: '+ Add',
          // Product page
          bHome: 'Home',
          bShop: 'Craft Beers & Shop',
          freshToday: 'Daily Fresh Arrival',
          originText: '<strong>Verviers Local Short Circuit:</strong> Curated Belgian craft breweries, gourmet glaces, and exceptional spirits. Fresh daily dispatch.',
          reviews: '4.9 (48 verified reviews)',
          varLabel: 'Size / Option:',
          addToCart: 'Add to Cart',
          delivTitle: '30-min Delivery',
          delivSub: 'In Verviers & surroundings',
          coldTitle: 'Cold Chain Guaranteed',
          coldSub: 'Refrigerated van transport',
          freshTitle: '100% Freshness',
          freshSub: '24h satisfaction guarantee',
          payTitle: 'Secure Payment',
          paySub: 'Credit Cards, Apple Pay, Cash',
          acc1: 'Product Details & Local Origin',
          acc2: 'Storage & Serving Tips',
          acc3: 'Express Delivery in Verviers',
          // Shop page
          shopBHome: 'Home',
          shopBAisles: 'Craft Beers & Shop',
          shopBadge: 'THE GREAT CRAFT BEER, DRINKS & GLACE MARKET',
          shopTitle: 'All Our Fresh Beverages & Gourmet Glaces',
          shopDesc: 'Authentic Belgian beers, sparkling fruit sodas, artisan gelato pints, and premium Kentucky bourbon delivered chilled to your door in 30 minutes.',
          shopCoupon: '1st Order Promo Code',
          shopCouponSub: '-10% off from 25€ order',
          shopCount: 'Showing <strong>16</strong> fresh products',
          shopSort: 'Sort by:'
        },
        fr: {
          navHome: 'Accueil',
          navShop: 'Bières Artisanales & Boutique',
          navAbout: 'Notre Histoire',
          navFaq: 'F.A.Q & Aide',
          navContact: 'Contact & Magasin',
          navCat: 'TOUTES LES CATEGORIES',
          navExpress: 'Livraison express en 30 min',
          searchPlaceholder: 'Rechercher bières, sodas frais, glaces, bourbon, vins...',
          delivery: 'Livraison GRATUITE dès 25€ • Livré chez vous en 30 min',
          quality: '100% Sélection Artisanale & Fraîcheur Garantie',
          cartItemsLabel: 'Articles',
          addBtn: '+ Ajouter',
          // Product page
          bHome: 'Accueil',
          bShop: 'Rayons Frais',
          freshToday: 'Arrivage du jour',
          originText: '<strong>Circuit Court Verviers :</strong> Sélection artisanale de brasseries belges, glaces gourmet et spiritueux d\'exception.',
          reviews: '4.9 (48 avis vérifiés)',
          varLabel: 'Format / Option :',
          addToCart: 'Ajouter au Panier',
          delivTitle: 'Livraison 30 min',
          delivSub: 'À Verviers (4800)',
          coldTitle: 'Chaîne du froid',
          coldSub: 'Véhicule frigo',
          freshTitle: '100% Fraîcheur',
          freshSub: 'Garantie 24h',
          payTitle: 'Paiement sécurisé',
          paySub: 'Bancontact & CB',
          acc1: 'Description & Origine Locale',
          acc2: 'Conseils de Conservation',
          acc3: 'Livraison Express à Verviers',
          // Shop page
          shopBHome: 'Accueil',
          shopBAisles: 'Rayons Frais & Boutique',
          shopBadge: 'LE GRAND MARCHÉ DES BIÈRES, BOISSONS & GLACES',
          shopTitle: 'Tous nos Produits & Boissons Fraîches',
          shopDesc: 'Bières artisanales belges, sodas pétillants rafraîchissants, glaces gourmet et spiritueux haut de gamme livrés chez vous en moins de 30 minutes.',
          shopCoupon: 'Code Promo 1ère Commande',
          shopCouponSub: '-10% dès 25€ d\'achats',
          shopCount: 'Affichage de <strong>16</strong> produits',
          shopSort: 'Trier par :'
        }
      };

      const selectedLang = lang === 'fr' ? 'fr' : 'en';
      const t = translations[selectedLang];
      localStorage.setItem('shop_verviers_lang', selectedLang);

      // Header & Navigation
      const elHome = document.getElementById('navLinkHome'); if (elHome) elHome.textContent = t.navHome;
      const elShop = document.getElementById('navLinkShop'); if (elShop) elShop.textContent = t.navShop;
      const elAbout = document.getElementById('navLinkAbout'); if (elAbout) elAbout.textContent = t.navAbout;
      const elFaq = document.getElementById('navLinkFaq'); if (elFaq) elFaq.textContent = t.navFaq;
      const elContact = document.getElementById('navLinkContact'); if (elContact) elContact.textContent = t.navContact;
      const elCat = document.getElementById('navCategoriesLabel'); if (elCat) elCat.textContent = t.navCat;
      const elExpress = document.getElementById('navExpressLabel'); if (elExpress) elExpress.textContent = t.navExpress;
      const elSearch = document.getElementById('mainSearchInput'); if (elSearch) elSearch.placeholder = t.searchPlaceholder;
      const elDel = document.getElementById('topDeliveryText'); if (elDel) elDel.textContent = t.delivery;
      const elQual = document.getElementById('topQualityText'); if (elQual) elQual.textContent = t.quality;
      const elItems = document.getElementById('floatingCartItemsLabel'); if (elItems) elItems.textContent = t.cartItemsLabel;

      // Product Detail Page
      const elBHome = document.getElementById('breadcrumbHome'); if (elBHome) elBHome.textContent = t.bHome;
      const elBShop = document.getElementById('breadcrumbShop'); if (elBShop) elBShop.textContent = t.bShop;
      const elFreshToday = document.getElementById('badgeFreshToday'); if (elFreshToday) elFreshToday.textContent = t.freshToday;
      const elOrigin = document.getElementById('guaranteeOriginText'); if (elOrigin) elOrigin.innerHTML = t.originText;
      const elReviews = document.getElementById('ratingCountText'); if (elReviews) elReviews.textContent = t.reviews;
      const elVarLabel = document.getElementById('variantLabel'); if (elVarLabel) elVarLabel.textContent = t.varLabel;
      const elAddBtn = document.getElementById('addToCartBtnText'); 
      if (elAddBtn && !elAddBtn.textContent.includes('Sold Out') && !elAddBtn.textContent.includes('RUPTURE')) {
        const price = document.getElementById('productPriceDisplay')?.textContent || '';
        elAddBtn.textContent = `${t.addToCart} • ${price}`;
      }
      const elDTitle = document.getElementById('badgeDelivTitle'); if (elDTitle) elDTitle.textContent = t.delivTitle;
      const elDSub = document.getElementById('badgeDelivSub'); if (elDSub) elDSub.textContent = t.delivSub;
      const elCTitle = document.getElementById('badgeColdTitle'); if (elCTitle) elCTitle.textContent = t.coldTitle;
      const elCSub = document.getElementById('badgeColdSub'); if (elCSub) elCSub.textContent = t.coldSub;
      const elFTitle = document.getElementById('badgeFreshTitle'); if (elFTitle) elFTitle.textContent = t.freshTitle;
      const elFSub = document.getElementById('badgeFreshSub'); if (elFSub) elFSub.textContent = t.freshSub;
      const elPTitle = document.getElementById('badgePayTitle'); if (elPTitle) elPTitle.textContent = t.payTitle;
      const elPSub = document.getElementById('badgePaySub'); if (elPSub) elPSub.textContent = t.paySub;
      const elAcc1 = document.getElementById('accordionTitle1'); if (elAcc1) elAcc1.textContent = t.acc1;
      const elAcc2 = document.getElementById('accordionTitle2'); if (elAcc2) elAcc2.textContent = t.acc2;
      const elAcc3 = document.getElementById('accordionTitle3'); if (elAcc3) elAcc3.textContent = t.acc3;

      // Shop Page
      const elShopBHome = document.getElementById('shopBreadcrumbHome'); if (elShopBHome) elShopBHome.textContent = t.shopBHome;
      const elShopBAisles = document.getElementById('shopBreadcrumbAisles'); if (elShopBAisles) elShopBAisles.textContent = t.shopBAisles;
      const elShopBadge = document.getElementById('shopHeroBadge'); if (elShopBadge) elShopBadge.textContent = t.shopBadge;
      const elShopTitle = document.getElementById('shopHeroTitle'); if (elShopTitle) elShopTitle.textContent = t.shopTitle;
      const elShopDesc = document.getElementById('shopHeroDesc'); if (elShopDesc) elShopDesc.textContent = t.shopDesc;
      const elShopCoupon = document.getElementById('shopCouponText'); if (elShopCoupon) elShopCoupon.textContent = t.shopCoupon;
      const elShopCouponSub = document.getElementById('shopCouponSub'); if (elShopCouponSub) elShopCouponSub.textContent = t.shopCouponSub;
      const elShopCount = document.getElementById('shopCountText'); if (elShopCount) elShopCount.innerHTML = t.shopCount;
      const elShopSort = document.getElementById('shopSortLabel'); if (elShopSort) elShopSort.textContent = t.shopSort;

      // Add to cart buttons on cards
      document.querySelectorAll('.product-add-btn, .product-btn-add').forEach(btn => {
        if (btn.textContent.includes('AJOUTER') || btn.textContent.includes('ADD') || btn.textContent.includes('Ajouter') || btn.textContent.includes('Add')) {
          btn.textContent = t.addBtn;
        }
      });

      const langSelect = document.getElementById('langSwitcher');
      if (langSelect) langSelect.value = selectedLang;
    },

    // 5. Render Cart Drawer Content & Progress
    renderCart: function () {
      const container = document.getElementById('cartItemsContainer');
      const subtotalEl = document.getElementById('cartSubtotal');
      const totalEl = document.getElementById('cartTotal');
      const deliveryEl = document.getElementById('cartDeliveryFee');
      const thresholdText = document.getElementById('thresholdText');
      const progressFill = document.getElementById('progressFill');

      if (!container) return;

      const subtotal = localCart.reduce((sum, item) => sum + (item.price * item.quantity), 0);

      // Free shipping progress calculation (Threshold: 25€)
      if (subtotal >= THRESHOLD) {
        if (thresholdText) {
          thresholdText.className = 'threshold-text reached';
          thresholdText.innerHTML = '<span style="display:inline-flex;align-items:center;margin-right:4px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></span> <strong>FREE Express Delivery</strong> unlocked in Verviers!';
        }
        if (progressFill) progressFill.style.width = '100%';
        if (deliveryEl) deliveryEl.innerHTML = '<span style="color: var(--color-primary); font-weight: bold;">FREE</span>';
      } else {
        const remaining = (THRESHOLD - subtotal).toFixed(2);
        const percent = Math.min(100, Math.round((subtotal / THRESHOLD) * 100));
        if (thresholdText) {
          thresholdText.className = 'threshold-text';
          thresholdText.innerHTML = `<span style="display:inline-flex;align-items:center;margin-right:4px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg></span> Add only <strong>${remaining.replace('.', ',')} €</strong> more for <strong>FREE Express Delivery</strong>!`;
        }
        if (progressFill) progressFill.style.width = percent + '%';
        if (deliveryEl) deliveryEl.textContent = 'Calculated at checkout';
      }

      if (subtotalEl) subtotalEl.textContent = subtotal.toFixed(2).replace('.', ',') + ' €';
      if (totalEl) totalEl.textContent = subtotal.toFixed(2).replace('.', ',') + ' €';

      if (localCart.length === 0) {
        container.innerHTML = `
          <div class="cart-empty-state">
            <div style="font-size: 0; margin-bottom: 12px; display: flex; justify-content: center;"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg></div>
            <h4 style="color: var(--color-text-title); font-size: 17px; font-weight: 800;">Your cart is currently empty</h4>
            <p style="font-size: 13px; color: var(--color-text-muted); max-width: 260px; text-align: center; margin: 8px auto 16px;">
              Discover Belgian craft beers, refreshing fruit sodas, and artisanal gelato delivered to your door!
            </p>
            <button type="button" class="btn-shop-green" onclick="window.theme.closeCart(); window.location.href='/collections/all';" style="margin: 0 auto; font-size: 13px; padding: 10px 20px;">
              Start Shopping
            </button>
          </div>
        `;
        return;
      }

      let html = '';
      localCart.forEach(item => {
        const lineTotal = (item.price * item.quantity).toFixed(2).replace('.', ',');
        html += `
          <div class="cart-item" data-id="${item.id}">
            <div class="cart-item-img">
              <img src="${item.image}" alt="${item.title}" onerror="this.src='https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&w=200&q=80'">
            </div>
            <div class="cart-item-details">
              <h4 class="cart-item-title">${item.title}</h4>
              <div class="cart-item-price">${lineTotal} €</div>
              <div class="cart-qty-control">
                <span class="qty-btn" onclick="window.theme.changeItemQty('${item.id}', ${item.quantity - 1})" aria-label="Decrease">−</span>
                <span class="qty-number">${item.quantity}</span>
                <span class="qty-btn" onclick="window.theme.changeItemQty('${item.id}', ${item.quantity + 1})" aria-label="Increase">+</span>
              </div>
            </div>
            <button type="button" class="cart-item-remove" onclick="window.theme.changeItemQty('${item.id}', 0)" title="Remove item" aria-label="Remove item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
          </div>
        `;
      });
      container.innerHTML = html;
    },

    // 6. Wishlist Management (Persistent & Synced Across All Page Components)
    initWishlist: function () {
      try {
        const savedWishlist = localStorage.getItem('shop_verviers_wishlist');
        if (savedWishlist) {
          const parsed = JSON.parse(savedWishlist);
          if (Array.isArray(parsed)) {
            wishlist = new Set(parsed.map(String));
          }
        }
      } catch (e) {}

      // Update badge counts
      const count = wishlist.size;
      document.querySelectorAll('#wishlistCount, .wishlist-count, .wishlist-badge').forEach(el => {
        el.textContent = count;
      });

      // Highlight active heart buttons across the entire page
      document.querySelectorAll('.product-wishlist-btn').forEach(btn => {
        const pid = String(btn.getAttribute('data-product-id') || '');
        if (pid && wishlist.has(pid)) {
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.remove('active');
          btn.setAttribute('aria-pressed', 'false');
        }
      });
    },

    toggleWishlist: function (btn, id) {
      if (!id && btn) {
        id = btn.getAttribute('data-product-id');
      }
      if (!id) return;
      const strId = String(id);
      const isCurrentlyAdded = wishlist.has(strId);

      if (isCurrentlyAdded) {
        wishlist.delete(strId);
        this.showToast("Removed from wishlist");
      } else {
        wishlist.add(strId);
        this.showToast("Added to wishlist");
      }

      // Persist to localStorage
      try {
        localStorage.setItem('shop_verviers_wishlist', JSON.stringify(Array.from(wishlist)));
      } catch (e) {
        console.warn('Could not save wishlist to localStorage:', e);
      }

      // Sync ALL buttons matching this ID on the page
      const matchingBtns = document.querySelectorAll(`.product-wishlist-btn[data-product-id="${strId}"]`);
      if (matchingBtns.length > 0) {
        matchingBtns.forEach(b => {
          if (!isCurrentlyAdded) {
            b.classList.add('active');
            b.setAttribute('aria-pressed', 'true');
          } else {
            b.classList.remove('active');
            b.setAttribute('aria-pressed', 'false');
          }
        });
      } else if (btn) {
        if (!isCurrentlyAdded) {
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.remove('active');
          btn.setAttribute('aria-pressed', 'false');
        }
      }

      // Update all wishlist badge counters
      const count = wishlist.size;
      document.querySelectorAll('#wishlistCount, .wishlist-count, .wishlist-badge').forEach(el => {
        el.textContent = count;
      });
    },

    // 7. Toast Notification
    showToast: function (msg) {
      let container = document.getElementById('toastContainer');
      if (!container) {
        container = document.createElement('div');
        container.id = 'toastContainer';
        container.className = 'toast-container';
        document.body.appendChild(container);
      }

      const toast = document.createElement('div');
      toast.className = 'toast';
      toast.innerHTML = `<span>✓</span> <span>${msg}</span>`;
      container.appendChild(toast);

      setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateY(10px)';
        toast.style.transition = 'all 0.3s ease';
        setTimeout(() => toast.remove(), 300);
      }, 3000);
    },

    // 8. Product Detail Gallery Image Switcher
    selectProductImage: function (src, thumbEl) {
      const mainImg = document.getElementById('mainProductImg');
      if (mainImg && src) {
        mainImg.style.opacity = '0.4';
        mainImg.src = src;
        setTimeout(() => { mainImg.style.opacity = '1'; }, 100);
      }
      if (thumbEl) {
        document.querySelectorAll('.thumb-item').forEach(el => el.classList.remove('active'));
        thumbEl.classList.add('active');
      }
    },

    // 9. Product Quantity Stepper (Never Cut Off)
    changeQuantity: function (delta) {
      const input = document.getElementById('Quantity');
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      val = Math.max(1, val + delta);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    },

    // 10. Instant Client-Side Multi-Faceted Collection & Shop Filtering
    shopFilters: {
      category: 'all',
      price: 'all',
      inStock: true,
      onSale: false
    },

    applyShopFilters: function () {
      const grid = document.getElementById('collectionGrid');
      if (!grid) return;
      const cards = grid.querySelectorAll('.product-card');
      const countEl = document.getElementById('shopCountText');
      const emptyState = document.getElementById('shopEmptyState');
      const activeTag = document.getElementById('shopActiveFilterTag');
      const activeLabel = document.getElementById('activeFilterLabel');

      const { category, price, inStock, onSale } = window.theme.shopFilters;
      let visibleCount = 0;

      cards.forEach(card => {
        const cat = (card.getAttribute('data-category') || '').toLowerCase();
        const priceVal = parseFloat(card.getAttribute('data-price') || '0');
        const isStock = card.getAttribute('data-stock') !== 'false';
        const isSale = card.getAttribute('data-sale') === 'true';

        let catMatch = (category === 'all') || cat.includes(category);
        
        let priceMatch = true;
        if (price === 'under-5') priceMatch = priceVal < 5.0;
        else if (price === '5-10') priceMatch = priceVal >= 5.0 && priceVal <= 10.0;
        else if (price === '10-25') priceMatch = priceVal > 10.0 && priceVal <= 25.0;
        else if (price === 'over-25') priceMatch = priceVal > 25.0;

        let stockMatch = !inStock || isStock;
        let saleMatch = !onSale || isSale;

        if (catMatch && priceMatch && stockMatch && saleMatch) {
          card.classList.remove('hidden-by-filter');
          card.classList.add('fade-in');
          visibleCount++;
        } else {
          card.classList.add('hidden-by-filter');
          card.classList.remove('fade-in');
        }
      });

      if (countEl) {
        countEl.innerHTML = `Showing <strong>${visibleCount}</strong> Products`;
      }

      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
      }

      if (activeTag && activeLabel) {
        if (category !== 'all') {
          activeTag.style.display = 'inline-flex';
          activeLabel.textContent = category.replace('-', ' ').toUpperCase();
        } else {
          activeTag.style.display = 'none';
        }
      }
    },

    filterCollection: function (categorySlug, btnEl) {
      window.theme.shopFilters.category = categorySlug.toLowerCase();
      
      // Update sidebar category button styles
      document.querySelectorAll('.sidebar-cat-btn').forEach(btn => {
        if (btn.getAttribute('data-filter') === categorySlug) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      // Update horizontal tabs if present
      if (btnEl && btnEl.classList.contains('category-tab-item')) {
        document.querySelectorAll('.category-tab-item').forEach(b => b.classList.remove('active'));
        btnEl.classList.add('active');
      }

      window.theme.applyShopFilters();
    },

    filterByPrice: function (priceRange) {
      window.theme.shopFilters.price = priceRange;
      window.theme.applyShopFilters();
    },

    filterByStock: function (inStockOnly) {
      window.theme.shopFilters.inStock = inStockOnly;
      window.theme.applyShopFilters();
    },

    filterBySale: function (onSaleOnly) {
      window.theme.shopFilters.onSale = onSaleOnly;
      window.theme.applyShopFilters();
    },

    resetShopFilters: function () {
      window.theme.shopFilters = {
        category: 'all',
        price: 'all',
        inStock: false,
        onSale: false
      };

      document.querySelectorAll('.sidebar-cat-btn').forEach(b => {
        b.classList.toggle('active', b.getAttribute('data-filter') === 'all');
      });

      const allRadio = document.querySelector('input[name="shopPriceFilter"][value="all"]');
      if (allRadio) allRadio.checked = true;

      const stockBox = document.getElementById('filterInStockOnly');
      if (stockBox) stockBox.checked = false;

      const saleBox = document.getElementById('filterOnSaleOnly');
      if (saleBox) saleBox.checked = false;

      window.theme.applyShopFilters();
      window.theme.showToast('All filters have been reset');
    },

    sortProducts: function (sortVal) {
      const grid = document.getElementById('collectionGrid');
      if (!grid) return;
      const cards = Array.from(grid.querySelectorAll('.product-card'));

      cards.sort((a, b) => {
        const priceA = parseFloat(a.getAttribute('data-price') || '0');
        const priceB = parseFloat(b.getAttribute('data-price') || '0');
        if (sortVal === 'price-ascending') return priceA - priceB;
        if (sortVal === 'price-descending') return priceB - priceA;
        return 0;
      });

      cards.forEach(card => grid.appendChild(card));
    },

    // 11. Instant Filter for Sections (Trending, Popular, New Arrivals)
    filterSection: function (sectionId, categorySlug, btnEl) {
      const sec = document.getElementById(sectionId) || (btnEl && btnEl.closest('section'));
      if (!sec) return;
      const cards = sec.querySelectorAll('.product-card');
      if (btnEl) {
        const parent = btnEl.parentElement;
        if (parent) {
          parent.querySelectorAll('.category-tab-item').forEach(b => b.classList.remove('active'));
          btnEl.classList.add('active');
        }
      }

      // Remove previous empty notice if present
      const existingNotice = sec.querySelector('.empty-filter-notice');
      if (existingNotice) existingNotice.remove();

      const categoryKeywordMap = {
        'all': [],
        'craft-beers': [
          'beer', 'biere', 'bière', 'ale', 'ipa', 'lager', 'chimay', 'duvel', 'leffe', 
          'karmeliet', 'jupiler', 'craft', 'brasserie', 'trappist', 'blonde', 'brune', 
          'triple', 'tripel', 'stout', 'pils', 'alcool', 'chouffe', 'vedett', 'orval', 
          'rochefort', 'westmalle', 'biere-et-boisson-alcoolisee'
        ],
        'cold-drinks': [
          'soda', 'coca', 'cola', 'fanta', 'sprite', 'drink', 'boisson', 'jus', 'juice', 
          'eau', 'water', 'redbull', 'monster', 'ice tea', 'icetea', 'oasis', 'schweppes', 
          'perrier', 'san pellegrino', 'chilled', 'cold', 'fraiche', 'fraîche', 'energy'
        ],
        'gourmet-glaces': [
          'glace', 'ice', 'cream', 'gelato', 'sorbet', 'ben', 'jerry', 'haagen', 'dazs', 
          'magnum', 'vanille', 'chocolat', 'fraise', 'dessert', 'glaces', 'frozen', 'gourmet-glaces'
        ],
        'cocktails': [
          'cocktail', 'paloma', 'mojito', 'spritz', 'seltzer', 'absolut', 'vodka', 'gin', 
          'bacardi', 'havana', 'margarita', 'aperol', 'campari', 'jack', 'daniel', 'whisky', 
          'whiskey', 'rhum', 'rum', 'spirit', 'batida', 'tequila', 'specialty goods', 'specialty-goods'
        ],
        'bourbon-spirits': [
          'bourbon', 'whisky', 'whiskey', 'vodka', 'gin', 'rhum', 'rum', 'spiritueux', 
          'spirit', 'spirits', 'tequila', 'cognac', 'ricard', 'pastis', 'liqueur', 'batida', 
          'baileys', 'jagermeister', 'specialty goods', 'specialty-goods', 'absolut'
        ],
        'bakery': [
          'bakery', 'boulangerie', 'croissant', 'pain', 'brioche', 'baguette', 'chips', 
          'crisps', 'snack', 'biscuit', 'lays', 'doritos', 'pringles', 'oeuf', 'egg', 'conserve'
        ]
      };

      const rawSlug = (categorySlug || 'all').toLowerCase();
      const keywords = categoryKeywordMap[rawSlug] || [rawSlug.replace('-', ' ')];

      let matchCount = 0;
      const MAX_PER_TAB = 16;

      cards.forEach(card => {
        const cat = (card.getAttribute('data-category') || '').toLowerCase();
        const type = (card.getAttribute('data-type') || '').toLowerCase();
        const title = (card.getAttribute('data-title') || card.querySelector('.product-title')?.textContent || '').toLowerCase();
        const tags = (card.getAttribute('data-tags') || '').toLowerCase();
        const tagText = (card.querySelector('.product-category-tag')?.textContent || '').toLowerCase();
        const collections = (card.getAttribute('data-collections') || '').toLowerCase();
        const isPoolItem = card.classList.contains('is-pool-item');

        const fullSearchable = `${cat} ${type} ${title} ${tags} ${tagText} ${collections}`;

        let isMatch = false;
        if (rawSlug === 'all') {
          if (!isPoolItem && matchCount < MAX_PER_TAB) {
            isMatch = true;
          }
        } else {
          for (let i = 0; i < keywords.length; i++) {
            const kw = keywords[i].toLowerCase();
            if (fullSearchable.includes(kw)) {
              isMatch = true;
              break;
            }
          }
        }

        if (isMatch && matchCount < MAX_PER_TAB) {
          card.classList.remove('hidden-by-filter');
          card.classList.add('fade-in');
          matchCount++;
        } else {
          card.classList.add('hidden-by-filter');
          card.classList.remove('fade-in');
        }
      });

      const grid = sec.querySelector('.trending-products-grid, .popular-products-grid, .new-arrivals-products-grid, [id$="Grid"], .product-grid');
      if (grid) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      }

      if (matchCount === 0 && rawSlug !== 'all') {
        if (grid) {
          const notice = document.createElement('div');
          notice.className = 'empty-filter-notice';
          const catLabel = btnEl ? btnEl.textContent.trim() : rawSlug.replace('-', ' ');
          notice.innerHTML = `
            <div style="font-size: 36px; margin-bottom: 8px;">❄️</div>
            <h4 style="font-size: 18px; font-weight: 800; color: var(--color-text-title); margin: 0 0 6px;">Fresh ${catLabel} Arrivals Coming Tonight</h4>
            <p style="font-size: 13.5px; color: var(--color-text-muted); max-width: 520px; margin: 0 auto 16px; line-height: 1.5;">
              Our delivery vans are stocked with chilled Belgian beers, sodas, and spirits. Browse our complete 1,000+ item catalog or select another department above!
            </p>
            <a href="/collections/all" class="btn-primary" style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; border-radius: var(--radius-full); text-decoration: none; font-weight: 800; font-size: 13px;">
              Explore Full Store Catalog →
            </a>
          `;
          grid.appendChild(notice);
        }
      }
    }
  };

  // DOMContentLoaded Event Listeners
  document.addEventListener('DOMContentLoaded', function () {
    // Initialize wishlist state & highlight saved hearts
    if (window.theme && window.theme.initWishlist) {
      window.theme.initWishlist();
    }

    // Attach cart open button events
    document.querySelectorAll('.open-cart-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.theme.openCart();
      });
    });

    const closeBtn = document.getElementById('closeCartBtn');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => window.theme.closeCart());
    }

    const overlay = document.getElementById('drawerOverlay');
    if (overlay) {
      overlay.addEventListener('click', () => window.theme.closeCart());
    }

    // Filter Buttons on Featured Collection / Tabs
    const filterBtns = document.querySelectorAll('.filter-tab-btn');
    const productCards = document.querySelectorAll('#productsGrid .product-card');

    filterBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        filterBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        const filter = this.getAttribute('data-filter');
        productCards.forEach(card => {
          const cat = card.getAttribute('data-category');
          if (filter === 'all' || cat === filter) {
            card.style.display = 'flex';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });

    // Countdown Timer for Deal of the Day
    let totalSeconds = 2 * 86400 + 14 * 3600 + 38 * 60 + 45;
    const daysEl = document.getElementById('shopifyCdDays') || document.getElementById('timerDays');
    const hoursEl = document.getElementById('shopifyCdHours') || document.getElementById('timerHours');
    const minutesEl = document.getElementById('shopifyCdMins') || document.getElementById('timerMinutes');
    const secondsEl = document.getElementById('shopifyCdSecs') || document.getElementById('timerSeconds');

    if (daysEl && hoursEl && minutesEl) {
      setInterval(() => {
        if (totalSeconds > 0) {
          totalSeconds--;
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          daysEl.textContent = String(days);
          hoursEl.textContent = String(hours).padStart(2, '0');
          minutesEl.textContent = String(minutes).padStart(2, '0');
          if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
        }
      }, 1000);
    }

    // Search bar live filter
    const searchForm = document.querySelector('.header-search-form');
    if (searchForm) {
      const searchInput = searchForm.querySelector('.search-input');
      if (searchInput) {
        searchInput.addEventListener('input', function () {
          const q = this.value.toLowerCase().trim();
          productCards.forEach(card => {
            const title = (card.querySelector('.product-title')?.textContent || '').toLowerCase();
            if (title.includes(q)) {
              card.style.display = 'flex';
            } else {
              card.style.display = 'none';
            }
          });
        });
      }
    }

    // Product Form AJAX Add to Cart
    const productForm = document.getElementById('productForm');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        window.theme.handleProductFormSubmit(e);
      });
    }

    // Initialize Theme (Dark/Light mode) & Cart
    window.theme.initTheme();
    window.theme.updateCartCounts();
    
    // Default to English unless user explicitly chose French
    const savedLang = localStorage.getItem('shop_verviers_lang') || 'en';
    window.theme.switchLanguage(savedLang);

    // Mobile Filter Sidebar Toggle (for Shop page)
    const filterToggleBtn = document.querySelector('.btn-mobile-filter-trigger');
    const shopSidebar = document.querySelector('.shop-sidebar');
    if (filterToggleBtn && shopSidebar) {
      filterToggleBtn.addEventListener('click', function () {
        shopSidebar.classList.toggle('mobile-open');
        document.body.style.overflow = shopSidebar.classList.contains('mobile-open') ? 'hidden' : '';
      });
    }

    // Close mobile filter on overlay click
    document.addEventListener('click', function (e) {
      if (shopSidebar && shopSidebar.classList.contains('mobile-open')) {
        if (!shopSidebar.contains(e.target) && !e.target.closest('.btn-mobile-filter-trigger')) {
          shopSidebar.classList.remove('mobile-open');
          document.body.style.overflow = '';
        }
      }
    });

    // Touch Swipe-to-Close for Mobile Nav Drawer
    const mobileDrawer = document.getElementById('mobileNavDrawer');
    if (mobileDrawer) {
      let touchStartX = 0;
      let touchCurrentX = 0;
      let isSwiping = false;

      mobileDrawer.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        isSwiping = true;
      }, { passive: true });

      mobileDrawer.addEventListener('touchmove', function (e) {
        if (!isSwiping) return;
        touchCurrentX = e.touches[0].clientX;
        const diff = touchStartX - touchCurrentX;
        if (diff > 0) {
          // Swiping left: move drawer
          mobileDrawer.style.transform = 'translateX(' + (-diff) + 'px)';
        }
      }, { passive: true });

      mobileDrawer.addEventListener('touchend', function () {
        if (!isSwiping) return;
        isSwiping = false;
        const diff = touchStartX - touchCurrentX;
        if (diff > 80) {
          // Swipe threshold met: close drawer
          window.theme.toggleMobileMenu(false);
        }
        mobileDrawer.style.transform = '';
      }, { passive: true });
    }
  });

  // Re-sync wishlist in Shopify Theme Customizer on section reload
  document.addEventListener('shopify:section:load', function () {
    if (window.theme && window.theme.initWishlist) {
      window.theme.initWishlist();
    }
  });
})();
